export default "__VITE_ASSET__rehc1EVp__"